import React from 'react';
import cIf from 'classnames';
import './content-box.scss';

type ContentBoxProps = {
    children: React.ReactNode;
    className?: string;
};

export function ContentBox(props: ContentBoxProps) {
    const { children, className } = props;
    return <div className={cIf(["content-box", className])}>{children}</div>;
}